import { useMemo } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function DocumentViewerDialog({
  document,
  isDarkMode,
  open,
  onOpenChange,
}) {
  const fileContent = useMemo(() => {
    if (!document?.document || !document?.fileType) return null;
    return `data:${document.fileType};base64,${document.document}`;
  }, [document]);

  if (!document) return null;

  const handleClose = () => onOpenChange(false);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent
        className={`max-w-5xl max-h-[90vh] overflow-y-auto rounded-2xl ${
          isDarkMode ? "bg-gray-800 text-white border-gray-700" : "bg-white text-gray-900 border-gray-200"
        }`}
      >
        <DialogHeader>
          <DialogTitle className={`text-xl font-semibold ${isDarkMode ? "text-white" : "text-gray-900"}`}>
            {document.fileName || "Document Viewer"}
          </DialogTitle>
        </DialogHeader>

        <div className="pt-4 space-y-6">
          {fileContent ? (
            <div
              className={`rounded-lg border overflow-hidden flex items-center justify-center bg-white ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              }`}
              style={{ minHeight: "400px", maxHeight: "70vh" }}
            >
              {/* PDF Viewer */}
              {document.fileType === "application/pdf" ? (
                <iframe
                  src={fileContent}
                  className="w-full h-[70vh]"
                  title="PDF Viewer"
                />
              ) : document.fileType.startsWith("image/") ? (
                // Image Viewer
                <img
                  src={fileContent}
                  alt={document.fileName || "Document Preview"}
                  className="max-w-full max-h-[70vh] object-contain"
                />
              ) : (
                <p className="text-sm text-gray-500">
                  Preview not supported for this file type.
                </p>
              )}
            </div>
          ) : (
            <p className="text-sm text-gray-500">No document to preview.</p>
          )}

          <div className="flex justify-end pt-4">
            <Button variant="outline" onClick={handleClose}>
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
